import { render, staticRenderFns } from "./ExtrajudicialRecoveryEnterprisePage.vue?vue&type=template&id=7debf790"
import script from "./ExtrajudicialRecoveryEnterprisePage.vue?vue&type=script&lang=js"
export * from "./ExtrajudicialRecoveryEnterprisePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports